/**
 * Куда писать в поддержку.
 *
 * Один адрес на всё приложение: он стоит на лендинге, на странице
 * оплаты и в апелляции. Разложенный по трём файлам, он однажды
 * поменяется в двух из них — и покупатель со сломанной оплатой
 * напишет в мёртвый канал.
 *
 * Через переменную окружения, потому что у заказчика канал свой,
 * и менять его пересборкой из исходников он не должен.
 */
export const SUPPORT_URL: string =
  import.meta.env.VITE_SUPPORT_URL ?? 'https://t.me/cryptochangek_support_bot'
